<template>
  <v-card elevation="8">
    <v-img :src="joinCard.img" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
      <v-card-title>Mission Card</v-card-title>
    </v-img>
    <v-divider></v-divider>
    <v-card-text>
      <div class="subtitle-2">Mission Name: {{joinCard.name}}</div>
      <div class="subtitle-2">Quota: {{ joinCard.players.length + '/' + joinCard.quota}}</div>
      <v-btn outlined :disabled="joinCard.players.length >= joinCard.quota" small color="primary" @click="clickDialog">Join</v-btn>
      <v-chip-group multiple column active-class="primary--text">
        <v-chip pill outlined close v-for="(tag, index) in joinCard.players" :key="index + tag.name" @click:close="remove(tag.name)">
          <v-avatar left>
            <v-img :src="tag.avatar"></v-img>
          </v-avatar>
          {{ tag.name }} - {{tag.class}}
        </v-chip>
      </v-chip-group>
    </v-card-text>
    <v-divider></v-divider>
    <joinDialog/>
  </v-card>
</template>

<script>
import joinDialog from '../../dialog/joinDialog/joinDialog.vue'
const firebase = require('firebase')
const database = firebase.database()
export default {
  name: 'joinCard',
  data: () => ({
    joinCard: {
      players: []
    }
  }),
  components: {
    joinDialog
  },
  created () {
    this.joinCard = this.$store.state.joinCard
    database.ref('/mission_list').once('value', e => {
      let data = e.val().filter(item => item.name === this.joinCard.name)
      let size = data[0].quota === 8 ? 6 : 4
      this.$store.commit('setSize', size)
    })
    console.log(this.joinCard.name)
  },
  methods: {
    clickDialog () {
      this.$store.commit('setJoinDialogStatus', true)
    },
    remove (name) {
      if (this.$store.state.controlBar.edit_status) {
        this.joinCard.players = this.joinCard.players.filter(player => player.name !== name)
        database.ref('/game_record/' + this.$store.state.loginCard.key + '/players').set(this.joinCard.players)
        this.$store.commit('setSnackBar', {
          icon: 'far fa-check-circle',
          color: 'primary',
          status: true,
          text: 'Player Removed',
          timeout: 2000
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
